import React, { useEffect, useState } from "react";
import {useLocation} from "react-router-dom";
import { chevronBottom } from "./SVG";

export default function Header() {
  const [menu, setMenu] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(null);

  // Handle click on menu button and store clicked menu item in state


  function scrollFunc() {
    if (window.scrollY >= 60) {
      setIsSticky(true);
    } else setIsSticky(false);
  }
  useEffect(() => {
    window.addEventListener("scroll", scrollFunc);
  }, []);
  useEffect(() => {
    if (menu) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [menu]);
  useEffect(() => {
    window.scrollTo(0, 0);
    setMenu(false);
    document.body.classList.remove("active");
  }, [location]);
  const close = (e) => {
    if (e.target === e.currentTarget) setMenu(false);
  };



  useEffect(() => {
    const handleScroll = () => {
      const sections = document.querySelectorAll('section');
      sections.forEach((section) => {
        const sectionTop = section.offsetTop;
        const sectionHeight = section.clientHeight;
        if (window.scrollY >= sectionTop - sectionHeight / 3) {
          setActiveLink(section.getAttribute('id'));
        }
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header
      className={
        "header " + (menu ? "active" : "") + (isSticky ? " sticky" : "")
      }
      id="header"
    >
      <div className="auto__container">
        <div className="header__inner">
          <a href="#/" className="header__inner-logo">
            <img src="/images/logo.svg" alt="" />
          </a>
          <div className="header__inner-main">
            <nav className={"nav " + (menu ? "active" : "")} onClick={close}>
              <ul className="nav__inner">
                <li>
                  <a className={activeLink === "what_we_do" ? 'active_link' : ''} href="/#what_we_do">What we do?</a>
                </li>
                <li>
                  <a className={activeLink === "services" ? 'active_link' : ''}
                      href="#services">Services</a>
                </li>
                <li>
                  <a className={activeLink === "grant" ? 'active_link' : ''}
                      href="#grant">How we Work?</a>
                </li>
                <li>
                  <a className={activeLink === "projects" ? 'active_link' : ''}
                      href="#projects">Projects</a>
                </li>
                <li>
                  <a  className={activeLink === "team" ? 'active_link' : ''}
                      href="#team">Team</a>
                </li>
                <li>
                  <a className={activeLink === "contact2" ? 'active_link' : ''}
                      href="#contact2">Contact</a>
                </li>
              </ul>
            </nav>
            <div className="lang">
              <div className="langHead">
                <div className="langHead__icon">
                  <img src="/images/icons/flags/gb.svg" alt="" />
                </div>
                <p>EN</p>
                {chevronBottom}
              </div>
              {/* <div className="langDrop">
                <p>
                  <span>
                    <img src="/images/icons/flags/gb.svg" alt="" />
                  </span>
                  EN
                </p>
                <p>
                  <span>
                    <img src="/images/icons/flags/gb.svg" alt="" />
                  </span>
                  FR
                </p>
              </div> */}
            </div>
            <div
              className={"burger " + (menu ? "active" : "")}
              onClick={() => {
                setMenu(!menu);
              }}
            >
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
